import { Suspense } from "react";
import { Navigate } from "react-router-dom";

import { DEFAULT_START_PAGES } from "../constants/appConstants";
import { useAuthStore } from "../stores/authStore";

export function StartPageRedirect() {
  const scope = useAuthStore((state) => state.user?.scope);
  return (
    <Navigate
      to={DEFAULT_START_PAGES[scope ?? ""] ?? "/app/agency-console"}
      replace
    />
  );
}

export const LoadingFallback = () => (
  <div className="flex items-center justify-center min-h-screen">
    <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[var(--brand-primary)]"></div>
  </div>
);

export function SuspenseWrapper({ children }: { children: React.ReactNode }) {
  return <Suspense fallback={<LoadingFallback />}>{children}</Suspense>;
}
